import {
  COTIZADOR_ACT_UPDATE_QUOTE_BEGIN,
  COTIZADOR_ACT_UPDATE_QUOTE_SUCCESS,
  COTIZADOR_ACT_UPDATE_QUOTE_FAILURE,
  COTIZADOR_ACT_UPDATE_QUOTE_DISMISS_ERROR,
} from './constants'
import { REACT_APP_COTIZADOR_API } from '../../../common/config'
import axios from 'axios'

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function actUpdateQuote(id, args = {}, callback) {
  return (dispatch) => {
    // optionally you can have getState as the second argument
    dispatch({
      type: COTIZADOR_ACT_UPDATE_QUOTE_BEGIN,
    })

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      const doRequest = axios.patch(`${REACT_APP_COTIZADOR_API}/cotizador/v1/quotes/${id}`, args)
      doRequest.then(
        (res) => {
          dispatch({
            type: COTIZADOR_ACT_UPDATE_QUOTE_SUCCESS,
            data: res,
          })
          callback('UPDATE', true)
          resolve(res)
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: COTIZADOR_ACT_UPDATE_QUOTE_FAILURE,
            data: { error: err },
          })
          reject(err)
          callback('UPDATE', false)
        },
      )
    })

    return promise
  }
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissActUpdateQuoteError() {
  return {
    type: COTIZADOR_ACT_UPDATE_QUOTE_DISMISS_ERROR,
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case COTIZADOR_ACT_UPDATE_QUOTE_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        actUpdateQuotePending: true,
        actUpdateQuoteError: null,
      }

    case COTIZADOR_ACT_UPDATE_QUOTE_SUCCESS:
      // The request is success
      return {
        ...state,
        actUpdateQuotePending: false,
        actUpdateQuoteError: null,
        newQuoteResponse: action.data.data,
      }

    case COTIZADOR_ACT_UPDATE_QUOTE_FAILURE:
      // The request is failed
      return {
        ...state,
        actUpdateQuotePending: false,
        actUpdateQuoteError: action.data.error,
      }

    case COTIZADOR_ACT_UPDATE_QUOTE_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        actUpdateQuoteError: null,
      }

    default:
      return state
  }
}
